import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { SelectYourNumber } from "@common/SelectYourNumber/SelectYourNumber";
import { NationalDirectoryEnquiriesList, TITLE_INHERIT_STYLE } from "@constants";
import "./css/NationalDirectoryEnquiriesPage.scss";
import { useNDDPreferences } from "./hook/useNDDPreferences";
import { EDirectoryPreferences } from "./interface/INDDPreference";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";

export const NationalDirectoryEnquiriesPage = () => {
    const {
        selectedPreference,
        updateNDDPreference,
        getNDDPreferenceState,
        updateNDDPreferenceState,
        getNDDPreferences,
        isLoading,
    } = useNDDPreferences();

    const { t } = useTranslation(["profile", "common"]);

    return (
        <div className="nationalDirectory">
            <SelectYourNumber>
                <Card className="nationalDirectory-card" elevation={2}>
                    {isLoading && <AbsoluteLoader />}
                    <CardHeader
                        className="card-header card-header__right"
                        title={t("profile:nationalDirectoryEnquiries")}
                        titleTypographyProps={TITLE_INHERIT_STYLE}
                    />
                    <CardContent>
                        <div className="card-header__circle" />
                        <HandleErrorAndLoading
                            error={getNDDPreferenceState.error}
                            isLoading={false}
                            retryFetch={getNDDPreferences}
                        >
                            {updateNDDPreferenceState.error && (
                                <Typography color="error" variant="h5">
                                    {t("common:genericError")}
                                </Typography>
                            )}
                            {NationalDirectoryEnquiriesList.map((NDDPreferenceList, index) => (
                                <Fragment key={NDDPreferenceList.name}>
                                    <FormControlLabel
                                        className="nationalDirectory-card-list"
                                        control={
                                            <Radio
                                                checked={NDDPreferenceList.name === selectedPreference}
                                                name="nationalDirectoryPreferencesList"
                                                value={NDDPreferenceList.name}
                                                onChange={(event) =>
                                                    updateNDDPreference(event.target.value as EDirectoryPreferences)
                                                }
                                            />
                                        }
                                        label={t(NDDPreferenceList.label as any)}
                                    />
                                    {index !== NationalDirectoryEnquiriesList.length - 1 && <Divider />}
                                </Fragment>
                            ))}
                        </HandleErrorAndLoading>
                    </CardContent>
                </Card>
            </SelectYourNumber>
        </div>
    );
};
